<template>
  <div id="services">
    <div id="header" class="d-flex flex-row justify-content-end align-items-center">
      <div class="col2">
        <div v-html="servicesLg.lg1.periodTitle.period2"></div>
      </div>
    </div>
    <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
      <row class="rowa" v-for="(service, index) in filteredServices.lg1" :key="index" :servicesLg1='service' :servicesLg2='filteredServices.lg2[index]'></row>
    </div>
    <div id="additionalServices" v-if="additionalServices" class="d-flex flex-column align-items-left justify-content-center">
      <div class="lg1" v-html="additionalServices.lg1.label_value"></div>
    </div>
    <legalNoticeCenter :legalNoticeLg="legalNoticeLg"></legalNoticeCenter>
  </div>
</template>

<script>
  import Row from './rowServices'
  import LegalNoticeCenter from './legalNoticeCenter'

  export default {
    name: 'IbisStylesRatesHorizontalV1Services',
    props: {
      servicesLg: Object
    },
    components: {
      row: Row,
      'legalNoticeCenter': LegalNoticeCenter
    },
    computed: {
      filteredServices: function () { // remove additional services if necessary
        if (this.servicesLg.lg1.settings.additional_services === '1') {
          return { lg1: this.servicesLg.lg1.otherServices.regular.slice(0, -1), lg2: this.servicesLg.lg2.otherServices.regular.slice(0, -1) }
        } else {
          return { lg1: this.servicesLg.lg1.otherServices.regular, lg2: this.servicesLg.lg2.otherServices.regular }
        }
      },
      additionalServices: function () {
        if (this.servicesLg.lg1.settings.additional_services === '1') {
          let regularLg1 = this.servicesLg.lg1.otherServices.regular
          let regularLg2 = this.servicesLg.lg2.otherServices.regular
          return { lg1: regularLg1[regularLg1.length - 1], lg2: regularLg2[regularLg2.length - 1] }
        } else {
          return null
        }
      },
      legalNoticeLg () {
        if (this.servicesLg) {
          return {lg1: this.servicesLg.lg1.subtitles['1'], lg2: this.servicesLg.lg2.subtitles['1']}
        } else {
          return null
        }
      }
    }
  }
</script>

<style lang="scss">
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibisstyles.scss";

#ibisStylesRatesHorizontalV1 #services {
  margin-top: 52 * 100vh / $srcHeight!important;

  #header {
    font-family: 'Gotham-Bold';
    @include fontSize(25);
    text-transform: uppercase;
    text-align: right;
    border-bottom: 2px solid black;
  }

  #rows {
    width: 100%;

    .rowa:nth-of-type(n+6){
      display:none!important;
    }
  }

  #additionalServices {
    @include heightPercent(120);
    line-height: 1.2em;

    .lg1, .lg2 {
      p {
        font-family: "Gotham-Book";
        margin-bottom: 0px;
        line-height: 1.2em;
        display: inline-block;

        &:first-letter {
          text-transform: uppercase;
        }
      }
      p:nth-of-type(2) {
        text-transform: lowercase;
        font-family: "Gotham-BookItalic";
        @include fontSize(28);
      }
    }

    .lg1 {
      margin-top: 0.5vh;
      @include fontSize(46);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/services/services.vue